import { ref, useGetAlgoliaSearchIndex } from '#imports'
import { useGuestStore } from '~/store/guest'
import { normalizationFrameHits } from '@/utils/normalize/algoliaSearchNormalize'

export const useBestSellerProducts = () => {
  const loading = ref(false)
  const result = ref<any>()
  const { catalogFilter, frameFilter } = useGuestStore().currentGift ?? {}

  const algoliaIndex = useGetAlgoliaSearchIndex()
  const getBestSellerProducts = async (
    items = 4,
    attributesToRetrieve?: string[],
  ) => {
    const res = await $fetch<any>(`/api/get-bestseller-products`, {
      query: {
        algoliaIndex,
        catalogFilter: catalogFilter?.product,
        frameFilter,
        items,
        attributesToRetrieve,
      },
    })

    result.value = normalizationFrameHits(res.hits)
    loading.value = false
  }

  return {
    result,
    loading,
    getBestSellerProducts,
  }
}
